import {TOOLTIPS} from '../../components/onboarding/constants';
import {SET_HELP_INTRO_DATA, SET_TOOLTIPS_DATA, SET_TOOLTIP_STEP, SKIP_TOOLTIPS} from './constants';

const getInitialState = () => ({
  skipped: false,
  steps: Object.keys(TOOLTIPS).reduce((acc, val) => ({...acc, [val]: 1}), {}),
  isHelpIntroDisabled: true,
});

const initialState = getInitialState();
const tooltipsReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'DESTROY': {
      return getInitialState();
    }
    case SET_TOOLTIP_STEP:
      return {
        ...state,
        steps: {
          ...state.steps,
          [action.page]: action.step,
        },
      };
    case SET_TOOLTIPS_DATA:
      return {
        ...state,
        skipped: action.skipped,
        steps: action.steps,
      };
    case SKIP_TOOLTIPS:
      return {
        ...state,
        skipped: true,
      };
    case SET_HELP_INTRO_DATA:
      return {
        ...state,
        isHelpIntroDisabled: action.data,
      };
    default:
      return state;
  }
};

export default tooltipsReducer;
